import React, { useEffect, useState, useRef } from 'react';
import Banner from "../Components/Banner";

const LandForSaleMap = () => {
  const [iframeHeight, setIframeHeight] = useState('100vh');
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'sensoreal-height' && event.data.source === 'land') {
        setIframeHeight(event.data.height + 'px');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      {/* Banner */}
      <Banner
        title={"Land for Sale"}
        bgImage="bg-land-banner"
      />

      {/* Sensoreal Webfeed */}
      <div className="land-map-container" style={{
        width: '100%',
        margin: '0 auto',
      }}>
        <iframe
          ref={iframeRef}
          src="/sensoreal-land.html"
          width="100%"
          frameBorder="0"
          style={{ border: 0, height: iframeHeight, minHeight: '100vh' }}
          title="Banyan Hill Land for Sale"
          allowFullScreen
          scrolling="no"
        />
      </div>
    </>
  );
};

export default LandForSaleMap;